import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Products from "@/components/site/Products";
import Cookbook from "@/components/site/Cookbook";
import Story from "@/components/site/Story";
import LaunchList from "@/components/site/LaunchList";
import Social from "@/components/site/Social";
import Footer from "@/components/site/Footer";
import Admin from "@/pages/Admin";

const Landing = () => (
    <>
        <Navbar />
        <main>
            <Hero />
            <Marquee />
            <Products />
            <Cookbook />
            <Story />
            <LaunchList />
            <Social />
        </main>
        <Footer />
    </>
);

function App() {
    useEffect(() => {
        const lenis = new Lenis({ autoRaf: true, duration: 1.15 });
        window.__lenis = lenis;
        return () => {
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <div className="App bg-obsidian font-sans text-parchment">
            <div className="grain-overlay" aria-hidden="true" />
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/admin" element={<Admin />} />
                </Routes>
            </BrowserRouter>
            <Toaster theme="dark" position="bottom-right" />
        </div>
    );
}

export default App;
